
import React, { useState, useEffect } from "react";
import axios from "axios";
const testURL = process.env.REACT_APP_TEST_URL;
const productionURL = process.env.REACT_APP_PRODUCTION_URL;
const EscalationModal = ({ isOpen, onClose, issueId }) => {
  const [escalationActions, setEscalationActions] = useState([
    {
      IssueId: issueId || "",
      ActionId: "",
      RefId: "",
      RefType: "",
      Code: "",
      DescriptionName: "",
      ShortDescription: "",
      ActionBy: "",
      ActorName: "",
      AdditionalImages: "",
    }
  ]);

  // Allowed status values
  const statusOptions = [
    "OPEN",
    "CLOSED",
    "PROCESSING",
    "INFO-REQUESTED",
    "INFO-PROVIDED",
    "RESOLUTION-PROPOSED",
    "RESOLUTION-ACCEPTED",
    "RESOLUTION-CASCADED",
    "RESOLUTION-REJECTED",
  ];

  console.log("EscalationModal Received Issue ID Prop:", issueId);

  // Update IssueId whenever issueId prop changes
  useEffect(() => {
    if (issueId) {
      console.log("Updating Escalation Modal Issue ID:", issueId);
      setEscalationActions(prev => prev.map(action => ({ ...action, IssueId: issueId })));
    }
  }, [issueId]);

  // ✅ Handle Input Change
  const handleChange = (index, e) => {
    const { name, value } = e.target;
    const updatedActions = [...escalationActions];
    updatedActions[index][name] = value;
    setEscalationActions(updatedActions);
  };

  // ✅ Handle Additional Images
  const handleImageChange = (index, e) => {
    const { value } = e.target;
    const updatedActions = [...escalationActions];
    updatedActions[index].AdditionalImages = value.split(",").map(img => img.trim()).join(",");
    setEscalationActions(updatedActions);
  };

  // ✅ Add More Actions
  const addAction = () => {
    setEscalationActions([
      ...escalationActions,
      {
        IssueId: issueId,
        ActionId: "",
        RefId: "",
        RefType: "",
        Code: "",
        DescriptionName: "",
        ShortDescription: "",
        ActionBy: "",
        ActorName: "",
        AdditionalImages: "",
      }
    ]);
  };

  // ✅ Remove an Action
  const removeAction = (index) => {
    if (escalationActions.length > 1) {
      setEscalationActions(escalationActions.filter((_, i) => i !== index));
    }
  };

  // ✅ Handle Form Submission
  const handleSubmit = async () => {
    try {
      await axios.post(productionURL+"/api/ondc/escalate", escalationActions, {
        headers: { "Content-Type": "application/json" },
      });
      alert("Issue Escalated Successfully");
      onClose();
    } catch (error) {
      console.error("Error escalating issue:", error);
      alert("Failed to escalate issue");
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={(e) => e.target.classList.contains("modal-overlay") && onClose()}>
      <div className="modal-content">
        <button className="close-button" onClick={onClose}>✖</button>
        <h2 className="modal-title">Action Details</h2>

        <div className="modal-body">
          {escalationActions.map((action, index) => (
            <div key={index} className="action-section">
              <div className="input-group">
                <label>Issue ID</label>
                <input type="text" name="IssueId" value={action.IssueId} readOnly />
              </div>

              <div className="input-group">
                <label>Action ID</label>
                <input type="text" name="ActionId" value={action.ActionId} onChange={(e) => handleChange(index, e)} />
              </div>
              <div className="input-group">
                <label>Ref ID</label>
                <input type="text" name="RefId" value={action.RefId} onChange={(e) => handleChange(index, e)} />
              </div>
              <div className="input-group">
                <label>Ref Type</label>
                <input type="text" name="RefType" value={action.RefType} onChange={(e) => handleChange(index, e)} />
              </div>

              {/* 🔽 Dropdown for 'Code' 🔽 */}
              <div className="input-group">
                <label>Code</label>
                <select name="Code" value={action.Code} onChange={(e) => handleChange(index, e)}>
                  <option value="">Select Status</option>
                  {statusOptions.map((status) => (
                    <option key={status} value={status}>{status}</option>
                  ))}
                </select>
              </div>

              <div className="input-group">
                <label>Description Name</label>
                <input type="text" name="DescriptionName" value={action.DescriptionName} onChange={(e) => handleChange(index, e)} />
              </div>

              <div className="input-group">
                <label>Short Description</label>
                <input type="text" name="ShortDescription" value={action.ShortDescription} onChange={(e) => handleChange(index, e)} />
              </div>

              <div className="input-group">
                <label>Action By</label>
                <input type="text" name="ActionBy" value={action.ActionBy} onChange={(e) => handleChange(index, e)} />
              </div>

              <div className="input-group">
                <label>Actor Name</label>
                <input type="text" name="ActorName" value={action.ActorName} onChange={(e) => handleChange(index, e)} />
              </div>

              <div className="input-group">
                <label>Additional Images (Comma Separated URLs)</label>
                <input type="text" name="AdditionalImages" value={action.AdditionalImages} onChange={(e) => handleImageChange(index, e)} />
              </div>

              {/* Remove Action Button (Only if more than 1 action exists) */}
              {escalationActions.length > 1 && (
                <button className="remove-button" onClick={() => removeAction(index)}>Remove</button>
              )}
            </div>
          ))}

          {/* Add More Action Button */}
          <button className="add-button" onClick={addAction}>+ Add Another Action</button>
        </div>

        <button className="submit-button" onClick={handleSubmit}>Submit Escalation</button>
      </div>
    </div>
  );
};

export default EscalationModal;
